import React from 'react'

import i18n from 'live/services/i18n'
import widgetService from 'live/services/widgets'
import { reactWidgetWrapper } from 'live/widgets/decorators/react'

import { newStatetimelineReducer } from 'plugin-live-exploratory-viz/src/state-timeline/StateTimelineReducer'
import { StateTimelineMessage, StateTimelineState } from 'plugin-live-exploratory-viz/src/state-timeline/types'
import StateTimelineConfigForm from 'plugin-live-exploratory-viz/src/state-timeline/StateTimelineConfigForm'
import { withSuspenseWrapper } from 'plugin-live-exploratory-viz/components/SuspenseWrapper'

const widgetType = 'statetimeline'

const StateTimelineWidget = reactWidgetWrapper<StateTimelineState, StateTimelineMessage, DefaultChartConfigs>(
    withSuspenseWrapper(React.lazy(() => import('./component/Widget'))),
    newStatetimelineReducer,
    {
        mapConfigToProps(configs) {
            return {
                widget: configs.widget,
                dashboardTheme: configs.dashboardContext.theme
            }
        }
    }
)

const DEFAULT_CHART_CONFIG = {
    verticalEnabled: false,
    numberOfVisibleAxes: 6,
    legendEnabled: false,
    legendRight: false,
    hideTooltip: true,
    tooltipOption: 'off'
}

const policies = {
    layers: 1,
    legends: false,
    allowHideTooltip: false,
    allowYAxisConfig: false,
    allowGroupedYAxis: false,
    defaultReducer: 'list(*) at the end => @chain' //,
    // handleOwnMissingData: true
}

widgetService.register({
    type: widgetType,
    get name() {
        return 'State timeline'
    },
    description: i18n('state timeline description'),
    policies,
    config: DEFAULT_CHART_CONFIG,
    ui: { configForm: StateTimelineConfigForm },
    impl: StateTimelineWidget
})
